import { usingGet, usingPost, createProxyUrl, checkUrlAvailability } from '@ocean/api'
import { localization } from '@ocean/configs'
import { SessionUtils } from '@ocean/utils'
import { namespace } from 'modules/activityDetails/CompanyNoticeDetails/localization'

const { i18n } = localization

const I18_PATH = `${namespace}:companyNoticeDetails.document`

export const getCompanyNoticeDetails = (companyNoticeId: Guid, resultId?: Guid) => {
  const baseUrl = `companyNotices/details/${companyNoticeId}`
  const url = resultId ? `${baseUrl}/${resultId}` : baseUrl
  return usingGet(url, { useProxy: true })
}

export const confirmCompanyNotice = (activityId: Guid) =>
  usingPost(`CompanyNotices/ConfirmCompanyNotice`, { activityId })

export const confirmCompanyNoticeForITR = (activityId: Guid, usedId: Guid, itrId?: string | null) =>
  usingPost(`CompanyNotices/ConfirmCompanyNoticeITR`, {
    CompanyNoticeId: activityId,
    UserId: usedId,
    ItrId: itrId,
  })

export const checkDocumentUrlAvailability = (documentId: Guid) => {
  return checkUrlAvailability(
    createDocumentDownloadUrl(documentId),
    i18n.t(`${I18_PATH}.notAvailable`)
  )
}

export const createDocumentDownloadUrl = (documentId: Guid) => {
  const sessionToken = SessionUtils.getSessionToken() || ''
  return createProxyUrl(
    `companyNotices/getDocument?token=${sessionToken}&companyNoticeId=${documentId}&inline=true`
  )
}
